import { Loader } from '../common/loader';

const ReceivedInvitations = function ($scope, $element, invitationInteractor, eventsService) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.loader = new Loader($element[0]);
    invitationInteractor.withReceivedInvitations().then(() => {
      $ctrl.invitations = invitationInteractor.receivedInvitations;
      $ctrl.loader.remove();
      $scope.$digest();
    });
  };

  $ctrl.displayedInvitations = function () {
    if ($ctrl.invitations) return $ctrl.invitations.filter(i => !i.is_accepted)
  };

  $ctrl.refreshList = function () {
    $scope.$digest();
  };

  $ctrl.deleteInvitation = function (invitation) {
    return invitationInteractor.deleteReceivedInvitation(invitation)
      .then(() => $scope.$digest(), () => eventsService.publishSystemError('Failed to delete the invitation'));
  };

  $ctrl.acceptInvitation = function (invitation) {
    let name = invitation.coach;

    return invitationInteractor.acceptInvitation(invitation)
      .then(() => {
        eventsService.publishSystemMessage(`Invitation accepted! ${name} is now one of your coaches.`);
        $scope.$digest();
      }, () => eventsService.publishSystemError('Failed to accept invitation'));
  }
};

export default {
  name: 'receivedInvitations',
  obj: {
    controller: ReceivedInvitations,
    templateUrl: 'components/received_invitations.html'
  },
  deps: []
}